import React from 'react';
import { statusStyle } from '../../utils/reportFormat';

export default function StatusPill({ status, small }: { status: string; small?: boolean }) {
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ring-1 ring-inset ${statusStyle(status).badge} ${
        small ? 'px-1.5 py-0.5 text-[0.6875rem]' : 'px-2 py-0.5 text-xs'
      }`}
    >
      {status}
    </span>
  );
}
